module.exports = function () {
    var locationsActiveClass = 'careers-search-result__all-locations--visible';

    $('.careers-search-result__show-more').click(function (e) {
        e.preventDefault();

        var isHidden = $(this).data('locationsHidden');
        var $resultItem = $(this).closest('.careers-search-result');
        var $locations = $resultItem.find('.careers-search-result__all-locations');
        var showMoreText = isHidden ? 'Hide' : 'Show';
        
        if (isHidden) {
            $locations.addClass(locationsActiveClass);
            $locations.attr("aria-hidden", !isHidden);
        }
        else {
            $locations.removeClass(locationsActiveClass);
        }

        $(this).text(showMoreText);
        $(this).data('locationsHidden', !isHidden);
        $locations.attr("aria-hidden", !isHidden);
    });
};